/**
 * Shopify conversions API — UTM-attributed sales for the company.
 *
 * Endpoint: GET /bot/api/link-conversions[?start_date=YYYY-MM-DD&end_date=YYYY-MM-DD]
 * Returns: { configured, days, start_date, end_date, total_orders, revenue,
 *            clicks, conversion_rate, by_channel, by_product, recent }
 *
 * Called with no args → the backend serves its default recent window (so
 * existing callers like the Dashboard "Revenue from AI" card keep working).
 * Pass a start/end Date pair to scope the whole report to that range.
 */
import { getBaseUrl } from './utils';
import { getAuthHeaders } from './auth';

/** Format a Date as YYYY-MM-DD in local time (matches the dashboard API). */
function _formatDate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export async function getLinkConversions(startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.set('start_date', _formatDate(startDate));
  if (endDate) params.set('end_date', _formatDate(endDate));
  const qs = params.toString();
  const res = await fetch(`${getBaseUrl()}/bot/api/link-conversions${qs ? `?${qs}` : ''}`, {
    headers: { ...getAuthHeaders() },
  });
  if (!res.ok) throw new Error(`link-conversions ${res.status}`);
  return res.json();
}
